var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(" 其他选项必填 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: '如果选项中开启"其他"选项，此属性控制该值是否必填',
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c("el-switch", {
            on: { change: _vm.otherRequiredChange },
            model: {
              value: _vm.activeData.config.otherRequired,
              callback: function ($$v) {
                _vm.$set(_vm.activeData.config, "otherRequired", $$v)
              },
              expression: "activeData.config.otherRequired",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "排列方式" } },
        [
          _c(
            "el-radio-group",
            {
              directives: [
                { name: "removeAriaHidden", rawName: "v-removeAriaHidden" },
              ],
              model: {
                value: _vm.activeData.config.inline,
                callback: function ($$v) {
                  _vm.$set(_vm.activeData.config, "inline", $$v)
                },
                expression: "activeData.config.inline",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: true } }, [
                _vm._v(" 横向 "),
              ]),
              _c("el-radio-button", { attrs: { label: false } }, [
                _vm._v(" 纵向 "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("config-item-option", { attrs: { "active-data": _vm.activeData } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }